<template>
  <div id="page-user-view">
    <router-link :to="`/${$i18n.locale}/${$store.state.AppActiveUser.userRole}/orders/delivery-orders?order=${orderData && orderData.delivery_order ? orderData.delivery_order.id : ''}`">
      <div v-if="orderData && orderData.delivery_order" class="col-span-1 mb-[16px]">
        <div class="cursor-pointer px-[22px] py-[20px] border border-solid border-steam rounded-[8px] hover:border-[#1c5bfe]">
          <div class="flex items-center gap-1">
            <span>
              <shipblu-icon iconLibrary="phosphor" iconName="receipt" iconClass="text-[25px]"></shipblu-icon>
            </span>
            <p class="text-lg">{{$t('Delivery Exchange')}}</p> 
          </div>
          <div class="mt-4 grid grid-cols-2">
            <div>
              <p class="text-young-night sm:text-[14px] text-[12px]">{{$t('Tracking Number')}}</p>
              <p class="text-industrial-revolution sm:text-[14px] text-[12px] mt-[6px]"> {{orderData.delivery_order.tracking_number}}</p>
            </div>
            <div>
              <p class="text-young-night sm:text-[14px] text-[12px]">{{$t('Picked up On')}}</p>
              <p class="text-industrial-revolution sm:text-[14px] text-[12px] mt-[6px]">{{orderData.delivery_order.pickup_date ? common.gettingDate(new Date(orderData.delivery_order.pickup_date).toISOString()) : '-'}}</p>
            </div>
            <div class="mt-[14px]">
              <p class="text-young-night sm:text-[14px] text-[12px]">{{$t('Cash Amount')}}</p>
              <p class="text-industrial-revolution sm:text-[14px] text-[12px] mt-[6px]">
                {{ parseInt(orderData.delivery_order.cash_amount) > 0 ? (orderData.delivery_order.cash_amount).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2}) : 'N/A' }}
              </p>
            </div>
            <div class="mt-[14px]">
              <p class="text-young-night sm:text-[14px] text-[12px]">{{$t('Status')}}</p>
              <p class="text-industrial-revolution sm:text-[14px] text-[12px] mt-[6px]"> 
                {{orderData.delivery_order.status}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </router-link>
    <router-link :to="`/${$i18n.locale}/${$store.state.AppActiveUser.userRole}/orders/returns?order=${orderData && orderData.return_order ? orderData.return_order.id : ''}`">
      <div v-if="orderData && orderData.return_order" class="cursor-pointer px-[22px] py-[20px] border border-solid border-steam rounded-[8px] hover:border-[#1c5bfe] ">
        <div class="flex items-center gap-1">
          <span>
            <shipblu-icon iconLibrary="phosphor" iconName="receipt" iconClass="text-[25px]"></shipblu-icon>
          </span>
          <p class="text-primary text-lg">{{$t('Return Exchange')}}</p>
        </div>
        <div class="mt-4 grid grid-cols-2">
          <div>
            <p class="text-young-night sm:text-[14px] text-[12px]">{{$t('Tracking Number')}}</p>
            <p class="text-industrial-revolution sm:text-[14px] text-[12px] mt-[6px]"> {{orderData.return_order.tracking_number}}</p>
          </div>
          <div>
            <p class="text-young-night sm:text-[14px] text-[12px]">{{$t('Picked up On')}}:</p>
            <p class="text-industrial-revolution sm:text-[14px] text-[12px] mt-[6px]"> 
              {{orderData.return_order.pickup_date ? 
              common.gettingDate(new Date(orderData.return_order.pickup_date).toISOString()) : '-'}}
            </p>
          </div>
          <div class="mt-[14px]">
            <p class="text-young-night sm:text-[14px] text-[12px]">{{$t('Cash Refund')}}</p>
            <p class="text-industrial-revolution sm:text-[14px] text-[12px] mt-[6px]"> {{ parseInt(orderData.return_order.cash_amount) > 0 ? (orderData.return_order.cash_amount).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2}) : 'N/A' }}</p>
          </div>
          <div class="mt-[14px]">
            <p class="text-young-night sm:text-[14px] text-[12px]">{{$t('Status')}}</p>
            <p class="text-industrial-revolution sm:text-[14px] text-[12px] mt-[6px]"> {{orderData.return_order.status}}</p>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import common  from '@/assets/utils/common'
import ShipbluTable from '../../../layouts/components/NewShipBluTable.vue'
import ShipbluTr from '../../../layouts/components/ShipBluTr.vue'
import ShipbluTh from '../../../layouts/components/ShipBluTh.vue'
import ShipbluTd from '../../../layouts/components/ShipBluTd.vue'
import ShipbluCard from '@/layouts/components/ShipbluCard.vue'

export default {
  props: ['orderData'],
  data () {
    return {
      common,
      serviceLevels: [],
      editable: false,
      // status: [
      //   {
      //     title: 'Created',
      //     value: 'created',
      //     date: this.orderData.created
      //   },
      //   {
      //     title: 'Picked_up to Exchange',
      //     value: 'picked up to exchange',
      //     date: this.orderData.delivery_order.pickup_date
      //   },
      //   {
      //     title: 'Swapping',
      //     value: 'Swapping',
      //     date: this.orderData.delivery_order.delivered_date
      //   },
      //   {
      //     title: 'Exchanged',
      //     value: 'Exchanged',
      //     date: this.orderData.return_order.returned_date
      //   }
      // ],
      outboundOrderSelected: [],
      inboundOrderSelected: []
    }
  },
  watch: {
    orderData () {
      // this.status.forEach((item, index) => {
      //   switch (index) {
      //   case 0:
      //     item.date = this.orderData.created
      //     break
      //   case 1:
      //     item.date = this.orderData.delivery_order.pickup_date
      //     break
      //   case 2:
      //     item.date = this.orderData.delivery_order.delivered_date
      //     break
      //   case 3:
      //     item.date = this.orderData.return_order.returned_date
      //     break
      //   }
      // })
    }
  },
  methods: {
    goToOrderView (type, orderID) {
      this.$router.push({
        name: `${this.$store.state.AppActiveUser.userRole}-${type}`,
        params: {
          type,
          orderID
        }
      }).catch(() => {})
      this.$route.query.type = type
    }
  },
  components: {
    vSelect,
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    ShipbluCard
  }
}
</script>

<style lang="scss" scoped>
.package-border {
  border: 0.6px solid #1C5BFE;
  border-radius: 4px;
}
.divide {
  left: calc(50% - 40px);
  width: 80px;
  height: 100%;
}
.bg-darkgray {
  background: #BCC1C7;
}
.bg-border-blue {
  background: #1C5BFE;
  border: 2px solid #A0D0FD;
}
.active-border {
  border-bottom: 1px solid #1C5BFE;
  position: absolute;
  left: 50%;
  width: 100%;
}
.inactive-border {
  border-bottom: 0.6px solid #9DADC2;
  position: absolute;
  left: 50%;
  width: 100%;
}
.arrows {
  top: calc(50% - 8.25px);
  left: -17.5px;
  .text-green {
    color: #17814C;
  }
  .text-orange {
    color:#E2A171;
  }
}
[dir=rtl] .arrows {
  transform: rotate(180deg);
}
div.exchange-table {
  table {
    width: 100%;
    min-width: 500px;
    border-collapse: collapse;
    table-layout: fixed;
    white-space: nowrap;
    td {
      text-align: center;
      padding: 10px 0px 5px;
      font-size: 14px;
      color: #1c5bfe;
    }
    thead {
      border: 1px solid #0a3266;
      border-left: none;
      border-right: none;
      td {
        color: #6C84A3;
        font-weight: 500;
        text-transform: capitalize;
        font-size: 14px;
        padding: 14px 0;
      }
    }
  }
}
</style>
